import { GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

// Shared direct-Google sign-in button (Google Identity Services ID-token flow).
// onSuccess POSTs the id_token to /api/auth/google. A fresh social signup (or a
// returning user with an UNREVEALED server-assigned reward) is routed to the
// /welcome/reward experience — the reward itself is never regenerated client-side.
// onRewardRoute lets the host page suppress its own dashboard-redirect effect.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const GoogleAuthButton = ({ testId, text = "continue_with", onRewardRoute }) => {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  return (
    <div data-testid={testId} className="flex justify-center">
      <GoogleLogin
        onSuccess={async (resp) => {
          try {
            const r = await loginWithGoogle(resp.credential);
            toast.success(`Welcome, ${r.user?.name || "driver"}`);
            if (r?.show_reward) {
              onRewardRoute?.();
              navigate("/welcome/reward", { replace: true });
            }
          } catch (err) { toast.error(err.message || "Google sign-in failed"); }
        }}
        onError={() => toast.error("Google sign-in failed")}
        theme="filled_black" size="large" width="320" text={text} shape="pill"
      />
    </div>
  );
};
